import { z } from 'zod'
import { PLANNING_TAB_LINKS } from '../../constants/planning-tab-links'

export const planningTabLinkSchema = z.enum(
    PLANNING_TAB_LINKS.map(link => link.value) as [string, ...string[]]
).optional()
